var render, staticRenderFns
import script from "./TabMenu.vue?vue&type=script&lang=js"
export * from "./TabMenu.vue?vue&type=script&lang=js"
import style0 from "./TabMenu.vue?vue&type=style&index=0&id=4a670f24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports